// laravel passport

import { PbxHttpClient, PbxPublicHttpClient } from "@/services/httpclient";

const state = {
  user: [],
  clientId: [],
  messageQueue: [],
  hasWhatsappConfig: false,
  token: null,
};

const getters = {
  AUTHENTICATED(state) {
    return state.token != null ? true : false;
  },

  CURRENT_USER(state) {
    return state.user;
  },

  GET_JWT(state) {
    return state.token;
  },

  GET_ROLE(state) {
    return state.user.role_id;
  },

  GET_CLIENT_ID(state) {
    return state.clientId || null;
  },

  HAVE_WHATSAPP_CONFIG() {
    return state.hasWhatsappConfig || false;
  },
};

const mutations = {
  ADD_TOKEN: (state, payload) => {
    localStorage.setItem("token", payload);
    state.token = payload;
    // asignar token instancia axios
    PbxHttpClient.defaults.headers.common["Authorization"] = `Bearer ${payload}`;
  },

  UPDATE_CONNECTION_STATUS: (state, payload) => {
    state.messageQueue = payload;
  },

  //   UPDATE_CONNECTION_AGENT: (state, payload) => {
  //     state.user.connect = payload;
  //     localStorage.setItem("user", JSON.stringify(state.user));
  //   },

  UPDATE_USER: (state, payload) => {
    if (state.user && state.user.web_rtc && !payload.web_rtc) {
      payload.web_rtc = state.user.web_rtc;
    }
    state.user = payload;
    localStorage.setItem("user", JSON.stringify(state.user));
  },

  UPDATE_SERVER: (state, payload) => {
    state.user.client_id = payload;
    state.clientId = payload;
    localStorage.setItem("user", JSON.stringify(state.user));
    localStorage.setItem("clientId", JSON.stringify(state.clientId));
  },

  GET_LOCALSTORE: (state) => {
    // extraer token
    if (localStorage.getItem("token") !== null) {
      state.token = localStorage.getItem("token");
      PbxHttpClient.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
    }
    // extraer usuario
    if (localStorage.getItem("user") !== null) {
      state.user = JSON.parse(`${localStorage.getItem("user")}`);
    }
  },

  RESET_AUTH: (state) => {
    state.user = {
      id: 0,
      name: "",
      email: "",
      connect: 0,
      email_verified_at: "",
      role_id: 0,
      created_at: "",
      updated_at: "",
    };
    state.token = null;
    // localstore
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    delete PbxHttpClient.defaults.headers.common["Authorization"];
  },

  SAVE_HAS_WHATSAPP_CONFIG: (state, payload) => {
    state.hasWhatsappConfig = payload;
  },
};

const actions = {
  async SIGNUP(_e, payload) {
    try {
      const res = await PbxPublicHttpClient.post(`/subscribers/auth/register/`, payload);
      return res.data;
    } catch (error) {
      // console.error(error);
      return Promise.reject(error);
    }
  },

  async BUGREPORT(_e, payload) {
    try {
      const res = await PbxPublicHttpClient.post(`/report_bugs/`, payload);
      return res.data;
    } catch (error) {
      // console.error(error);
      return Promise.reject(error);
    }
  },

  async AUTHENTICATE({ commit }, credentials) {
    try {
      // console.log("token store", credentials);
      const apiURL = credentials.token != undefined ? "/loginBitrix/" : "/login/";
      const resjwt = await PbxPublicHttpClient.post(apiURL, credentials);
      commit("ADD_TOKEN", resjwt.data.token);
      commit("UPDATE_USER", resjwt.data);

      if (resjwt.data.client_id) commit("UPDATE_SERVER", resjwt.data.client_id);
      else commit("UPDATE_SERVER", localStorage.getItem("clientId"));

      if (typeof resjwt.data.userPause_id !== "undefined") {
        commit(
          "breaks/SET_ACTIVE_BREAK",
          {
            id: resjwt.data.userPause_id,
          },
          { root: true },
        );
      }
      return resjwt.data;
    } catch (error) {
      // console.error(error);
      return Promise.reject(error);
    }
  },

  async ACTIVE_USER({ commit }) {
    try {
      const res = await PbxHttpClient.get(`/me/`);
      commit("UPDATE_USER", {
        ...res.data.user,
        client: res.data.client,
        web_rtc: res.data.web_rtc || res.data.user?.web_rtc,
      });
      if (res.data.user.client_id) commit("UPDATE_SERVER", res.data.user.client_id);
      else commit("UPDATE_SERVER", JSON.parse(localStorage.getItem("clientId")));

      const pauseid = res.data.userPause_id === null ? {} : res.data.userPause_id;

      if (res.data.user.auto_connection) {
        this.dispatch("dialer/SET_IS_CONNECTED", true, { root: true });
      }

      if (res.data.userPause_id) {
        commit(
          "breaks/SET_ACTIVE_BREAK",
          {
            ...pauseid,
            pause: res.data.userPause[0].pause,
          },
          { root: true },
        );
      }
      return;
    } catch (error) {
      // console.error(error);
      return Promise.reject();
    }
  },

  async UPDATE_CONNECTION_AGENT({ state, commit }, payload) {
    try {
      let response;

      if (state.user.connect === 0) {
        response = await PbxHttpClient.get(`authServer/connect/?extension=${payload}`);
      } else if (state.user.connect === 1) {
        response = await PbxHttpClient.get(`authServer/desconnect/${state.user.id}`);
      }

      commit("UPDATE_CONNECTION_STATUS", response.data);
      // console.log("Respuesta", response);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async RESET_CONNECTION_AGENT({ state, commit }, extension) {
    try {
      if (state.user.connect === 1) {
        await PbxHttpClient.get(`authServer/desconnect/${state.user.id}`);
      }

      const response = await PbxHttpClient.get(`authServer/connect/?extension=${extension}`);

      commit("UPDATE_CONNECTION_STATUS", response.data);
      // console.log("Respuesta", response);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async DISCONNECT_QUEUES({ state }) {
    try {
      await PbxHttpClient.get(`authServer/desconnect/${state.user.id}`);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async UPDATE_USER({ commit }, payload) {
    try {
      const response = await PbxHttpClient.put(`/profile/update/${payload.id}`, payload.value);
      commit("UPDATE_USER", response.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async UPDATE_PASSWORD({ commit }, payload) {
    try {
      const response = await PbxHttpClient.post(`/profile/updatePassword`, payload);
      commit("UPDATE_USER", response.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * [UPDATE_TOKEN_CLIENT description]
   * Nota: Actualizar cliente establecido en token passport
   * @param {number} payload    [description]
   */
  async UPDATE_TOKEN_CLIENT({ commit }, payload) {
    try {
      const res = await PbxHttpClient.post(`/user_client/`, {
        client_id: payload,
      });
      commit("UPDATE_SERVER", payload);

      return res.data;
    } catch (error) {
      // console.error(error);
      return Promise.reject(error);
    }
  },

  async TRY_AUTO_LOGIN({ commit, dispatch }) {
    try {
      const token = localStorage.getItem("token");
      if (token === null) {
        // router.push({ name: "login" }).catch(err => {});
        return;
      } else {
        commit("ADD_TOKEN", token);
        // extension de la cola
        const extension = JSON.parse(localStorage.getItem("extension_queue"));
        if (extension) {
          commit("queue/STATUS_QUEUE", { extension: extension }, { root: true });
        }
        await dispatch("ACTIVE_USER");
        return true;
      }
    } catch (error) {
      // console.log(error);
      commit("RESET_AUTH");
      return false; //Promise.reject(error);
    }
  },

  async LOGOUT({ commit }) {
    try {
      this.dispatch("dialer/SET_IS_CONNECTED", false, { root: true });
      const res = await PbxHttpClient.post("/logout/");
      commit("RESET_AUTH");
      // localStorage.removeItem("token");
      // localStorage.removeItem("user");
      return res;
    } catch (error) {
      // console.error(error);
      return Promise.reject(error);
    }
  },
  RESET_AUTH({ commit }) {
    commit("RESET_AUTH");
  },

  async CHECK_WHATSAPP_CONFIG({ commit }) {
    try {
      const { data } = await PbxHttpClient.get(`/admin/config/whatsapps/`, {
        params: { page: 1, itemPerPage: 10 },
      });
      commit("SAVE_HAS_WHATSAPP_CONFIG", !!data.data.length);
    } catch (error) {
      console.log("error getting whatsapp configs", error);
      commit("SAVE_HAS_WHATSAPP_CONFIG", false);
    }
  },
};

// exportar propiedades
export const passport = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
